<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="350px"
      height="170px"
      style="margin-top:12vh;"
      class="tip-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">{{ title?title:'新建素材失败' }}</div>
      <div class="tip-content-wrap">
        <div class="content-text">{{ content }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogVisible=false" >知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: '',
      title: '',
      dialogVisible: false
    }
  },
  methods: {
    show(title,content) {
      this.content = content
      this.title = title
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-dialog {
  /deep/.el-dialog__body {
    padding: 20px 20px 15px;
  }
  /deep/.el-dialog__footer{
    text-align: center;
  }
  .title {
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .tip-content-wrap {
    margin-bottom: 10px;
    // .content-text {
    //   text-align: center;
    // }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>